import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import deDictionary from './de.json';
import ruDictionary from './ru.json';

const resources = {
  de: { translation: deDictionary },
  ru: { translation: ruDictionary },
};

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'de',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18next;
